export const config = {
  API_PATH: '/integrations/control-tool',
  ADMIN_SCOPE: ['admin/common'],
  FRONTLINE_SCOPE: ['frontline/common'],
}
